<template>
  <button
    class="transition-ease-in-out"
    @click="!disabled && $emit('update:modelValue', !modelValue)"
  >
    <div class="flex h-[34px] space-x-6">
      <div
        v-if="!modelValue"
        class="flex inline-flex h-8 w-8 items-center rounded-full border border-primary bg-primary p-2 text-white hover:border-primary hover:bg-white hover:text-primary"
      >
        <inline-svg :src="useAsset(`icons/base/plus.svg`)" />
      </div>

      <div
        v-else
        class="transition-ease-in-out group flex h-8 w-8 items-center justify-end space-x-3 rounded-3xl border border-primary bg-primary pl-0 hover:border-primary hover:bg-white lg:pl-4"
      >
        <div
          class="flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full bg-white group-hover:bg-primary group-hover:text-white hover:text-white"
        >
          <inline-svg :src="useAsset(`icons/base/check.svg`)" />
        </div>
      </div>
    </div>
  </button>
</template>

<script setup>
import InlineSvg from 'vue-inline-svg'
defineEmits(['update:modelValue'])
defineProps({
  modelValue: {
    type: [Boolean],
    default: false,
  },
  disabled: {
    type: [Boolean],
    default: false,
  },
})
</script>
